
if($(".login-popover").length > 0){
	$(".optionOne").attr('checked',true);
	loginPopover ();
}

function loginPopover (){
	$(".login-popover a.btn-login").on('click',function(){
		if($(".login-block").hasClass('closed')){
			$(".login-block").fadeIn("fast");
			$(".login-block").removeClass('closed');
		}else{
			$(".login-block").fadeOut("fast");
			$(".login-block").addClass('closed');
		}
	})

	$("input[type='radio']").on('click',function(){
		if($(".optionOne").is(':checked')){
			$(".login-body").show();
			$(".account-body").hide();
		}
		if($(".optionTwo").is(':checked')){
			$(".account-body").show();
			$(".login-body").hide();
		}
	})
};


if ($(".float-lo-div").length > 0) {
	var loanOfficerRemoveendpoint = loanOfficerRemove_endpoint;
	$(".main-footer.footer-option3").addClass("lo-footer-padding");
}

$(".lo-box-div .close-icon").on('click', function (event) {
	$.ajax({
		url: loanOfficerRemoveendpoint,
		type: 'GET',
		success: function (data) {
			$(".float-lo-div").hide();
			return data;
		}
	});
});